import React, { createContext, useContext } from 'react';
import { signOut, onAuthStateChanged } from '@/firebase';
import { auth } from '@/firebase';
import { cleanupPushOnLogout } from '@/services/pushNotifications';

const AuthContext = createContext();

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return ctx;
};

export const AuthProvider = ({ children, onLogout }) => {
  const [user, setUser] = React.useState(null);

  React.useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return unsubscribe;
  }, []);

  const handleLogout = async () => {
    console.log("🚀 Cerrando sesión...");
    try {
      await cleanupPushOnLogout();
      await signOut(auth);
      console.log("✅ Sesión cerrada");
      if (onLogout) onLogout();
    } catch (err) {
      console.error("❌ Error al cerrar sesión:", err.message);
    }
  };

  return (
    <AuthContext.Provider value={{ user, handleLogout }}>
      {children}
    </AuthContext.Provider>
  );
};
